module.exports = __webpack_public_path__ + "static/media/highlights (4).76d6e390.jpg";